import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useDispatch } from "react-redux";
import jwtEncode from "jwt-encode";
import { jwtDecode } from "jwt-decode";
import "./App.scss";
import Routes from "./routes";
import DefaultLayout from "./Component/Layout/DefaultLayout";
import Sidebar from "./Component/Layout/Sidebar";
import Header from "./Component/Layout/Header";
import apiClient from "./apiClient";
import { applicationId, UNO_URL } from "./env";
import { GET_CONFIGURATION, GET_USER_DETAILS, TAG_LIST } from "./apiClient/apiEndPoints";
import { saveUserData } from "./store/slice/userSlice";
import { saveConfig } from "./store/slice/configSlice";
import axios from "axios";
import { myApplicationList } from "./store/slice/applicationSlice";
import FullScreenLoader from "./Component/FullScreenLoader/fullScreenLoader";
import { addAssetTags } from "./store/slice/tagsSlice";
import { handleLogin } from "./utils/common";

function App() {
  const path = window.location.pathname;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [defaultRoute, setDefaultRoute] = useState(null);

  const getConfiguration = async () => {
    setLoading(true);
    try {
      let data = await apiClient.get(`${UNO_URL}${GET_CONFIGURATION}/${applicationId}`);
      //  data.data["UNO_URL"] = "http://localhost:3003";
      dispatch(saveConfig({ data: data.data }));
      getUserDetail(data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const checkLoggedStatus = (config) => {
    if (path.startsWith("/asset/details/")) {
      setDefaultRoute(path);
      setLoading(false);
      return;
    }
    handleLogin(config.redirectUri, jwtEncode);
  };

  const fetchApplication = async (token, config) => {
    try {
      var { data } = await axios.get(`${config.UNO_URL}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(myApplicationList(data.data));
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetTagsList = async (config) => {
    try {
      let data = await apiClient.get(`${config.UNO_URL}${TAG_LIST}/${config.assetFilterId}`);
      dispatch(addAssetTags(data));
    } catch (error) {
      console.log(error);
    }
  };

  const getUserDetail = async (config) => {
    try {
      let referrerFind = false;
      let navigateRedirectUri = path.startsWith("/asset/details/") ? path : null;
      let referrerToken = null;
      const urlParams = new URLSearchParams(window.location.search);
      const _tokenParam = urlParams.get("referrer");

      if (_tokenParam) {
        const decoded = jwtDecode(_tokenParam);
        referrerToken = decoded.token;
        localStorage.setItem("token", referrerToken);
        referrerFind = true;
        if (decoded.redirectUri.startsWith("/asset/details/")) navigateRedirectUri = decoded.redirectUri;
      }

      referrerToken = referrerToken || localStorage.getItem("token");

      let { data } = await axios.get(`${config.UNO_URL}${GET_USER_DETAILS}`, {
        headers: {
          Authorization: `Bearer ${referrerToken}`,
        },
      });

      const { token, user } = data.data;
      localStorage.setItem("token", token);
      dispatch(saveUserData({ token, user }));
      fetchApplication(token, config);
      getAssetTagsList(config);
      setDefaultRoute(navigateRedirectUri);
      setLoading(false);
    } catch (error) {
      console.error(error);
      checkLoggedStatus(config);
    }
  };

  useEffect(() => {
    getConfiguration();
  }, []);

  return (
    <>
      {loading ? (
        <FullScreenLoader loading={loading} />
      ) : (
        <HelmetProvider>
          <Router>
            <div className="main">
              <Routes defaultRoute={defaultRoute} />
            </div>
          </Router>
        </HelmetProvider>
      )}
    </>
  );
}

export default App;
